import { render, staticRenderFns } from "./SellingPoints.vue?vue&type=template&id=45fb674a&scoped=true&"
import script from "./SellingPoints.vue?vue&type=script&lang=ts&"
export * from "./SellingPoints.vue?vue&type=script&lang=ts&"
import style0 from "./SellingPoints.vue?vue&type=style&index=0&id=45fb674a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb674a",
  null
  
)

export default component.exports